import { Event } from '../Event'
import { ViewerContext } from '../../constants'

export interface ExpertCuratedItemVariationSelectedEventProperties {
  expert_curated_order_id: string
  sellable_id: string
}

export class ExpertCuratedItemVariationSelectedEvent extends Event<
  ExpertCuratedItemVariationSelectedEventProperties
> {
  static displayName = 'Expert Curated Item Variation Selected'

  static allowedViewerContexts = [ViewerContext.Consumer]
}
